export const manifest = {
  screens: {
    scr_u1ipuq: { name: "Home", route: "/", position: {"x":160,"y":220} },
    scr_0fzyhp: { name: "Menu", route: "/menu", position: {"x":1560,"y":220} },
  },
  sections: {
    sec_3ip259: { name: "Main navigation", x: 0, y: 0, width: 2920, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_3ip259", children: [
      { kind: "screen", id: "scr_u1ipuq" },
      { kind: "screen", id: "scr_0fzyhp" },
    ] },
  ],
}
